import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	overflow: auto;
`;

export const img = styled.div`
	position: relative;
	min-width: 150px;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> img {
		width: 100%;
		height: 100%;
		min-height: 50px;
		border-radius: 5px;
	}
`;

export const text = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.lightGray2};
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	> p {
		font-family: nunito-bold;
		color: #4f2170;
	}
`;
